
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Sarah Chen',
      role: 'Small Business Owner',
      content: 'NEXX provided exactly what we needed - reliable servers without the enterprise complexity. Their support team feels like an extension of our own IT department.',
      rating: 5
    },
    {
      name: 'Michael Rodriguez',
      role: 'IT Manager',
      content: 'The colocation services exceeded our expectations. 24/7 access, smart hands support, and 100% uptime SLA gave us the confidence to scale our operations.',
      rating: 5
    },
    {
      name: 'Lisa Park',
      role: 'Freelancer',
      content: 'Their residential proxies solution transformed my data collection workflow. Clean IPs, reliable rotation, and transparent pricing - exactly what I needed.',
      rating: 5
    },
    {
      name: 'David Kim',
      role: 'Startup Founder',
      content: 'From consultation to implementation, NEXX guided us through every step. Their customized approach saved us months of infrastructure planning.',
      rating: 5
    }
  ];

  return (
    <>
      <style>{`
        @keyframes spark {
          0% { transform: scale(0) rotate(0deg); opacity: 0; }
          25% { transform: scale(0.8) rotate(90deg); opacity: 1; }
          50% { transform: scale(1.2) rotate(180deg); opacity: 0.8; }
          75% { transform: scale(0.6) rotate(270deg); opacity: 1; }
          100% { transform: scale(0) rotate(360deg); opacity: 0; }
        }
        
        @keyframes underline-expand {
          0% { width: 0; }
          100% { width: 100%; }
        }
        
        .spark-text {
          position: relative;
          display: inline-block;
        }
        
        .spark-text::before,
        .spark-text::after {
          content: '✨';
          position: absolute;
          font-size: 0.6em;
          animation: spark 3s ease-in-out infinite;
          z-index: 10;
        }
        
        .spark-text::before {
          top: -8px;
          left: -12px;
          animation-delay: 0.5s;
        }
        
        .spark-text::after {
          bottom: -8px;
          right: -12px;
          animation-delay: 2s;
        }
        
        .underline-animate {
          position: relative;
          display: inline-block;
        }
        
        .underline-animate::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          height: 2px;
          background: linear-gradient(90deg, #22c55e, #16a34a);
          animation: underline-expand 3s ease-in-out infinite;
        }
      `}</style>
      
      <section className="py-12 bg-white relative overflow-hidden section-wave">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              We're addicted to making you win...<span className="spark-text text-nexx-green">literally</span>.
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Because you deserve <span className="underline-animate font-semibold">more than just basic</span>.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="p-4 bg-gray-50 rounded-lg border border-gray-200 hover:border-nexx-green hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="mb-3">
                  <Quote className="h-6 w-6 text-nexx-green mb-2" />
                  <div className="flex space-x-1 mb-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    "{testimonial.content}"
                  </p>
                </div>
                <div className="border-t pt-3">
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsSection;
